module.exports = __webpack_public_path__ + "static/media/mediaDummy.0ebedc3a.png";